import useI18n from '@i18n';
import BaseSanitizer from '@components/base/BaseSanitizer';

import RemaindCounter from '../RemaindCounter';

interface IHeaderProps {
    endDate: number;
    handleModal: () => void;
    onlyAffGmvGoals: boolean;
}

const Header: React.FC<IHeaderProps> = ({ endDate, handleModal, onlyAffGmvGoals }) => {
    const { t } = useI18n('Statistic');
    return (
        <div className="mb-4">
            <div className="flex flex-col justify-between lg:flex-row">
                <div>
                    <h3 className="font-medium text-p1 text-blueGray-800 xs:text-sub sm:text-h2">
                        {t('Your progress in the Incentive Program AliExpress')}
                    </h3>
                    <div>
                        <BaseSanitizer
                            html={t('Below are the objectives of the program execution...')}
                            tag="p"
                            options={{ allowedTags: ['a'] }}
                            className="inline mt-1 text-p3 text-blueGray-500 xs:text-p2"
                        />{' '}
                        <span className="text-blueGray-500 xs:text-p2">
                            {onlyAffGmvGoals
                                ? t(
                                      'The turnover of the amount is carried out on partner orders with delivery to the CIS countries for the current month.',
                                  )
                                : t(
                                      'The turnover of the amount is carried out on orders with delivery to the CIS countries for the current month.',
                                  )}
                        </span>
                    </div>
                </div>
                <div className="hidden lg:block">
                    <RemaindCounter endDate={endDate} handleModal={handleModal} />
                </div>
            </div>
        </div>
    );
};

export default Header;
